import React, { useMemo } from "react";
import { HiOutlineMoon, HiOutlineUsers } from "react-icons/hi2";
import { MdOutlineChecklist, MdOutlineHourglassEmpty } from "react-icons/md";
import TimesheetKpiCard from "../UpdatedTimeSheet/components/TimesheetRevamp/TimesheetKpiCard";
import {
  getExportTimesheetPayrollQuantity,
  getExportTimesheetSleepoverAllowanceUnits,
  parseBooleanVal,
  truncateDecimal,
} from "Utils/utils";

const SelectionSummary = ({ selectedWorkers, selectedChilds }) => {
  const summary = useMemo(() => {
    let count = 0;
    let quantity = 0;
    let sleepoverCount = 0;
    let sleepoverAllowanceUnits = 0;

    selectedChilds.forEach((element) => {
      count += element.children.length;
      element.children.forEach((citem) => {
        const itemQty = getExportTimesheetPayrollQuantity(citem);
        quantity += itemQty;
        if (parseBooleanVal(citem.sleepover)) {
          sleepoverCount += 1;
          sleepoverAllowanceUnits += getExportTimesheetSleepoverAllowanceUnits(
            citem
          );
        }
      });
    });

    const totalQuantity = truncateDecimal(quantity, 2);
    const sleepUnits = truncateDecimal(sleepoverAllowanceUnits, 2);

    return {
      count,
      quantity: totalQuantity,
      sleepoverCount,
      sleepoverAllowanceUnits: sleepUnits,
      ordinaryQuantity: truncateDecimal(
        Math.max(0, totalQuantity - sleepUnits),
        2
      ),
    };
  }, [selectedChilds]);

  const sleepoverCaption =
    summary.sleepoverCount > 0
      ? `${summary.sleepoverCount} sleepover${
          summary.sleepoverCount === 1 ? "" : "s"
        }${
          summary.ordinaryQuantity > 0
            ? ` · ${summary.ordinaryQuantity} other`
            : ""
        }`
      : "No sleepovers selected";

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h5 className="mb-0 text-sm font-bold text-[#0F172A]">
          Selection Summary
        </h5>
        <p className="mb-0 text-[11px] font-medium text-[#64748B]">
          {summary.count === 0
            ? "Select items from the worker list to export"
            : `${summary.count} item${summary.count === 1 ? "" : "s"} ready`}
        </p>
      </div>
      <div
        className="grid grid-cols-1 gap-2 sm:grid-cols-3"
        aria-label="Export selection summary"
      >
        <TimesheetKpiCard
          label="Selected members"
          value={selectedWorkers.length}
          unit="workers"
          caption="Workers in current selection"
          icon={HiOutlineUsers}
          tone="muted"
        />
        <TimesheetKpiCard
          label="Items selected"
          value={summary.count}
          unit="items"
          caption="Timesheets chosen for export"
          icon={MdOutlineChecklist}
          tone="brand"
        />
        <TimesheetKpiCard
          label="Selected quantity"
          value={summary.quantity}
          unit="units"
          valueTitle={`${summary.quantity} units (${sleepoverCaption})`}
          caption={sleepoverCaption}
          captionTitle={
            summary.sleepoverCount > 0
              ? `${summary.sleepoverCount} sleepover timesheet${
                  summary.sleepoverCount === 1 ? "" : "s"
                } (${summary.sleepoverAllowanceUnits} sleepover unit${
                  summary.sleepoverAllowanceUnits === 1 ? "" : "s"
                } for 10pm–6am; ${summary.ordinaryQuantity} other)`
              : "No sleepovers selected"
          }
          icon={
            summary.sleepoverCount > 0 ? HiOutlineMoon : MdOutlineHourglassEmpty
          }
          tone={summary.sleepoverCount > 0 ? "brand" : "approve"}
        />
      </div>
    </div>
  );
};

export default SelectionSummary;
